<ycn-base-autocomplete
    class="input-group field-input-group"
    [buttonType]="'icon-search'"
    [defaultResults]="defaultResults"
    [globalSearch]="true"
    [placeholder]="searchPlaceholder"
    [searchType]="'global_search'"
    [showMoreResultsUrl]="true"
    (blurHandler)="searchPlaceholder = BLURRED_PLACEHOLDER"
    (focusHandler)="searchPlaceholder = ''"
    (submitHandler)="selectResult($event)">
</ycn-base-autocomplete>
